import React, {useState} from 'react';
import githubEn from '../assets/github_engraved.png';
import go from '../assets/go.png';
import images from './buildImages';

const ProjectList = ({info}) => {
  const [thumbImg, setThumbImg] = useState(null);

  const toggleThumb = (e) => {
    let tileId = e.target.id;
    let thumb = tileId ? images[tileId] : null
    setThumbImg(thumb);
  }

  const clearThumb = () => {
    setThumbImg(null);
  }
  
  let colors = ["#3FDE9A","#FA2D57","#FD9900","#167AFF","#000000","#FFFFFF","#FDCC01"]
  return info.map((el,i) => {
    return ((i !== 4)
            ? <div key={i} className="wrapper">
                <div  className="gray-effect"
                      onMouseEnter={toggleThumb}
                      onMouseLeave={clearThumb}
                      id={i}>
                  <div className="links">
                    {  el.liveUrl ? <a id={i} href={el.liveUrl} target="_blank" rel="noopener noreferrer"><img src={go} alt="source"></img></a> : null}
                    <a id={i} href={el.gitUrl} target="_blank" rel="noopener noreferrer"><img src={githubEn} alt="source"></img></a>
                  </div>
                </div>
                <div
                  className="project-item"
                  style={{"background":`${colors[Math.round(i % colors.length)]}`}}
                ><h3>{el.title}</h3>
                  <p id="project">{el.description}</p>
                </div>
              </div>
            : <div key={i} className="thumbnail">{thumbImg ? <img src={thumbImg} alt="thumbnail"/> : null}</div>)
  });


}

export default ProjectList;